
import * as actionTypes from "../actionTypes";
import * as constants from "../Constatnts";
import axios from "axios";



export function getOffers() {
  return async (dispatch, getState) => {

    const token = getState().user.uat;

    const response = await axios.get(
      constants.API_URL + "/catalog/offers",
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );

    let offers = [];

    if (
      response &&
      response.data &&
      Object.prototype.hasOwnProperty.call(response.data, "code") &&
      response.data.code === "0" &&
      Object.prototype.hasOwnProperty.call(response.data, "Offers") &&
      Array.isArray(response.data.Offers)
    ) {
      offers = response.data.Offers;
    }
if (!offers || offers.length === 0) {
    return [];
}

return offers.filter(o => !o.IsDeleted);
  };
}
// export function getOffers(registrationID) {
//   return (dispatch) => {
//     return database
//       .collection("Offers")
//       .where("RegistrationID", "==", registrationID)
//       .orderBy("ActionOn", "desc")
//       .get()
//       .then((querySnapshot) => {
//         const offers = [];
//         querySnapshot.forEach((doc) => {
//           offers.push({
//             key: doc.id,
//             ...doc.data(),
//           });
//         });
//         //    console.log("Get Offers", offers);
//         return offers;
//         // dispatch({ type: actionTypes.GET_OFFER, offers })
//       })
//       .catch((error) => {
//         console.log(error);
//       });
//   };
// }

export function saveOffer(offer, key) {
  return async (dispatch, getState) => {
    try {
      const token = getState().user.uat;
      let response = {};

      if (key !== "") {
        // Update existing account
        response = await axios.put(
          `${constants.API_URL}/catalog/offer/${key}`,
          offer,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );
      } else {
        // Create new account
        response = await axios.post(
          `${constants.API_URL}/catalog/offer`,
          offer,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );
      }

      if (response.data.code === "0") {
        if (key) {
          return key;
        } else {
          return response.data.data.key;
        }
      }

      return null;
    } catch (error) {
      console.error("API Error:", error);
      throw error;
    }
  };
}


export function saveCouponCode(couponCode) {
  return async (dispatch, getState) => {
    try {
      const token = getState().user.uat;
      let response = {};

   
        // Create new coupon
        response = await axios.post(
          `${constants.API_URL}/crm/coupon`,
          couponCode,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );
          return response.data.data.key;
    } catch (error) {
      console.error("API Error:", error);
      throw error;
    }
  };
}


export function deleteOffer(key) {
  return async (dispatch, getState) => {
    try {
      const token = getState().user.uat;

      const response = await axios.delete(
        `${constants.API_URL}/catalog/offer/${key}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      // API-level error handling
      if (response.data.code !== "0") {
        throw new Error(response.data.message || "Delete failed");
      }

      return response.data;

    } catch (error) {
      console.error("Error deleting product group:", error);
      throw error;
    }
  };
}




export function getOfferDetails(key) {
  return async (dispatch, getState) => {
    try {
      const token = getState().user.uat;
      const response = await axios.get(
        `${constants.API_URL}/catalog/offers/${key}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      return response.data.offer;
    } catch (error) {
      console.error("API Error:", error);
      throw error;
    }
  };
}



export function getCouponDetails(
couponID
) {
  return async (dispatch, getState) => {
    try {
      const token = getState().user.uat;

      const response = await axios.get(
        `${constants.API_URL}/coupanDetails?couponID=${couponID}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      return response.data.Coupons;
    } catch (error) {
      console.error("API Error:", error);
      throw error;
    }
  };
}


// export function getApplicableOffers(registrationID) {
//   return async (dispatch, getState) => {
//     return database
//       .collection("Offers")
//       .where("RegistrationID", "==", registrationID)
//       .where("IsDeleted", "==", false)
//       .get()
//       .then((querySnapshot) => {
//         const offers = [];
//         querySnapshot.forEach((doc) => {
//           offers.push({
//             key: doc.id,
//             ...doc.data(),
//           });
//         });
//         let applicableOffers = [];
//         var days = [
//           "Sunday",
//           "Monday",
//           "Tuesday",
//           "Wednesday",
//           "Thursday",
//           "Friday",
//           "Saturday",
//         ];
//         if (offers.length > 0) {
//           console.log("offers", offers);
//           for (let index = 0; index < offers.length; index++) {
//             const offer = offers[index];
//             // if(offer.hasOwnProperty("Type") && offer.Type ==="Coupon")
//             // {
//             //     console.log('it is coupon')
//             //     continue
//             // }
//             if (offer.AllStores) {
//               // For All Stores
//               // console.log(offer.Name + "  " + new Date(offer.ValidityFrom));
//               if (
//                 new Date(offer.ValidityFrom).setHours(0, 0, 0, 0) <=
//                   new Date().setHours(0, 0, 0, 0) &&
//                 new Date().setHours(0, 0, 0, 0) <=
//                   new Date(offer.ValidityTo).setHours(0, 0, 0, 0)
//               ) {
//                 // Validity Check
//                 if (
//                   offer.SpecificDay != "" &&
//                   offer.SpecificDay.toLowerCase() === "yes"
//                 ) {
//                   // Specific Day Selected
//                   if (offer.SpecificDays.includes(days[new Date().getDay()])) {
//                     // Check Specific Day
//                     applicableOffers.push(offer);
//                   }
//                 } else {
//                   applicableOffers.push(offer);
//                 }
//               }
//             } else {
//               for (let index = 0; index < offer.Stores.length; index++) {
//                 const store = offer.Stores[index];

//                 if (store.value === getState().user.store.key) {
//                   if (
//                     new Date(offer.ValidityFrom).setHours(0, 0, 0, 0) <=
//                       new Date().setHours(0, 0, 0, 0) &&
//                     new Date().setHours(0, 0, 0, 0) <=
//                       new Date(offer.ValidityTo).setHours(0, 0, 0, 0)
//                   ) {
//                     // Validity Check
//                     if (
//                       offer.SpecificDay != "" &&
//                       offer.SpecificDay.toLowerCase() === "yes"
//                     ) {
//                       // Specific Day Selected
//                       if (
//                         offer.SpecificDays.includes(days[new Date().getDay()])
//                       ) {
//                         // Check Specific Day
//                         applicableOffers.push(offer);
//                       }
//                     } else {
//                       applicableOffers.push(offer);
//                     }
//                   }
//                 }
//               }
//             }
//           }
//         }
//         // console.log(applicableOffers);
//         dispatch({ type: actionTypes.GET_APPLICABLE_OFFERS, applicableOffers });
//         // return applicableOffers;
//       })
//       .catch((error) => {
//         console.log(error);
//       });
//   };
// }

export function getApplicableOffers(registrationID) {
  return async (dispatch, getState) => {
    let offers = [];
    const token = getState().user.uat;
    const response = await axios.get(constants.API_URL + "/setup/offers", {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    if (response && response.data && response.data.offers) {
      console.log("offers", offers);
      offers = response.data.offers;
    }
    let applicableOffers = [];
    var days = [
      "Sunday",
      "Monday",
      "Tuesday",
      "Wednesday",
      "Thursday",
      "Friday",
      "Saturday",
    ];
    if (offers.length > 0) {
      console.log("offers", offers);
      for (let index = 0; index < offers.length; index++) {
        const offer = offers[index];
        if (offer.AllStores) {
          // For All Stores
          if (
            new Date(offer.ValidityFrom).setHours(0, 0, 0, 0) <=
              new Date().setHours(0, 0, 0, 0) &&
            new Date().setHours(0, 0, 0, 0) <=
              new Date(offer.ValidityTo).setHours(0, 0, 0, 0)
          ) {
            // Validity Check
            if (
              offer.SpecificDay != "" &&
              offer.SpecificDay.toLowerCase() === "yes"
            ) {
              // Specific Day Selected
              if (offer.SpecificDays.includes(days[new Date().getDay()])) {
                // Check Specific Day
                applicableOffers.push(offer);
              }
            } else {
              applicableOffers.push(offer);
            }
          }
        } else {
          for (let index = 0; index < offer.Stores.length; index++) {
            const store = offer.Stores[index];

            if (store.value === getState().user.store.key) {
              if (
                new Date(offer.ValidityFrom).setHours(0, 0, 0, 0) <=
                  new Date().setHours(0, 0, 0, 0) &&
                new Date().setHours(0, 0, 0, 0) <=
                  new Date(offer.ValidityTo).setHours(0, 0, 0, 0)
              ) {
                // Validity Check
                if (
                  offer.SpecificDay != "" &&
                  offer.SpecificDay.toLowerCase() === "yes"
                ) {
                  // Specific Day Selected
                  if (offer.SpecificDays.includes(days[new Date().getDay()])) {
                    // Check Specific Day
                    applicableOffers.push(offer);
                  }
                } else {
                  applicableOffers.push(offer);
                }
              }
            }
          }
        }
      }
    }
    dispatch({ type: actionTypes.GET_APPLICABLE_OFFERS, applicableOffers });
  };
}

export function validateCoupon(
  storeID,
  couponCode,
  customerID
) {
  return async (dispatch, getState) => {
    try {
      const token = getState().user.uat;

      const response = await axios.post(
        `${constants.API_URL}/crm/validatecoupon`,
        {
          StoreID: storeID,
          CouponCode: couponCode,
          CustomerID: customerID,
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      return response.data.coupon;
    } catch (error) {
      console.error("API Error:", error);
      throw error;
    }
  };
}
